<template>
  <div class="ws-static-locale">
    <div class="ws-static-locale__top">
      <div class="ws-static-locale__top__label textPrimary--text">
        <span>
          {{label}}
        </span>
        <span v-if="isLoading">
          <v-progress-circular
            v-if="isLoading"
            size="20"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </span>
      </div>
      <div class="ws-static-locale__top__btn ws-button-group">
        <WsBtn
          v-show="!isUpdate&&_showFields"
          minWidth="100px"
          @click="$_onUpdate()"
        >
          <v-icon left>mdi-pencil</v-icon>編輯
        </WsBtn>
        <WsBtn
          minWidth="100px"
          @click="$_onExport()"
          v-show="!isUpdate"
        >
          匯出
        </WsBtn>
        <WsBtn
          minWidth="100px"
          @click="$_onImportOpen()"
          v-show="!isUpdate"
        >
          匯入
        </WsBtn>
        <div
          class="ws-static-locale__top__btn__update"
          v-show="isUpdate"
        >
          <WsBtn
            @click="$_onCancel()"
            color="textSecondary"
            outlined
          >取消</WsBtn>
          <WsBtn @click="$_onSubmit()">
            儲存
          </WsBtn>
        </div>
      </div>
    </div>
    <div class="ws-static-locale__content mt-6">
      <WsCard>
        <WsStaticLocaleRead
          v-show="!isUpdate"
          :showFields="_showFields"
        ></WsStaticLocaleRead>
        <WsStaticLocaleUpdate
          v-show="isUpdate"
          v-model="updateData"
        ></WsStaticLocaleUpdate>
      </WsCard>
    </div>
    <WsImportDialog
      ref="importDialog"
      :label="label"
      :fields="fields"
      @create-submit="$_onCreateSubmit($event)"
    />
  </div>
</template>
<script>
import download from "@/services/api/v1/download";
export default {
  data: () => ({
    isUpdate: false,
    languageData: null,
    otherData: null,
    updateData: null,
    isLoading: false,
  }),
  methods: {
    $_onUpdate() {
      this.isUpdate = !this.isUpdate;
    },
    $_onCancel() {
      this.isUpdate = !this.isUpdate;
    },
    async $_getTranslate() {
      try {
        const res = await this.$axios.get(
          `/language_package_show/${this._selectingLocale}`
        );
        this.languageData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    async $_getOtherData() {
      const res = await this.$axios.get(`/language_package_field`);
      this.otherData = res.data.data;
    },
    async $_setMessage() {
      if (!this._selectingLocale) return;
      this.isLoading = true;
      await this.$_getTranslate();
      await this.$_getOtherData();
      this.$root.$i18n.mergeLocaleMessage(
        this.languageData.lang,
        this.languageData.payload
      );
      this.updateData = this._showFields;
      this.isLoading = false;
    },
    async $_onSubmit() {
      try {
        this.isLoading = true;
        let newObj = { lang: this.languageData.lang };
        newObj.payload = {};
        let newPayload = {};
        this.updateData.forEach((item) => {
          newPayload[item.value] = item.translate === ""
          ? null
          : item.translate
        });
        newObj.payload = newPayload;

        const res = await this.$axios.patch(
          `/package_language/${this.languageData.id}`,
          newObj
        );
        this.languageData = res.data.data;
        this.isUpdate = false;
        this.isLoading = false;
      } catch (error) {
        this.isUpdate = false;
        this.isLoading = false;
        alert(error);
      }
    },
    async $_onExport() {
      let downloadUrl = null
      for (let key in this.fields) {
        downloadUrl = this.fields[key].downloadUrl ? this.fields[key].downloadUrl : null
      }
      try {
        download.xlsxDownload({
          url: downloadUrl,
        });
      } catch (error) {
        alert(error);
      }
    },
    $_onImportOpen() {
      this.$refs.importDialog.open();
    },
    async $_onCreateSubmit($event) {
      this.$refs.importDialog.startLoading();
      try {
        await this.$axios.post(`${$event.uploadUrl}`, $event.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })
        this.$refs.importDialog.close();
        this.$_setMessage();
      } catch (error) {
        alert(error)
      } finally {
        this.$refs.importDialog.stopLoading();
      }
    }
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _showFields() {
      if (!this.otherData || !this.languageData) return null;
      let newArr = [...this.otherData.payload];
      newArr.forEach((item) => {
        if (this.languageData.payload[item.value]) {
          item.translate = this.languageData.payload[item.value];
        } else if (item.label) {
          item.translate = "";
        }
      });
      return newArr;
    },
  },
  watch: {
    _selectingLocale: {
      handler() {
        this.$root.$i18n.locale = this._selectingLocale;
        this.$_setMessage();
      },
    },
    isUpdate: {
      handler() {
        if (this.isUpdate) {
          this.updateData = this._showFields;
        }
      },
    },
  },
  mounted() {
    this.$_setMessage();
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    fields: Object,
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-static-locale.scss";
</style>